import React from 'react';
import { useSelector } from 'react-redux';
import { convertToHTML } from 'services/constants';
export default function ValueCreation({
  getValueByKey = () => '',
  renderMarkdown = () => '',
  // convertToHTML = () => '',
}) {
  const { displayUserConfig } = useSelector(({ fundData }) => fundData);

  const sectionsConfig =
    displayUserConfig?.data?.ic_report_ui_config?.sections || [];

  const excludeKey = ['competitive_landscape_summary'];
  const allClientKeys =
    displayUserConfig?.data?.client_ui_config?.sections
      ?.flatMap((section) => section.values || [])
      ?.map((item) => item.key) || [];

  const valueCreationSection = sectionsConfig.find(
    (section) => section.key === 'value_creation'
  );

  const sectionTitle = valueCreationSection?.title;

  const filteredFields =
    valueCreationSection?.values?.filter(
      (field) =>
        (field?.key && allClientKeys?.includes(field.key)) ||
        excludeKey.includes(field.key)
    ) || [];

  const renderField = ({ key, title }) => {
    const rawValue = getValueByKey(key);
    const isHtmlField = key.includes('landscape'); // update logic if needed
    const converted = convertToHTML(String(rawValue));
    const containsHTML =
      /<\/?(table|thead|tbody|tr|th|td|ul|li|h[1-6]|strong|em|br|p)>/.test(
        converted
      );

    return (
      <div key={key}>
        <p className="web-typography-value">{title}:</p>
        {containsHTML ? (
          <div
            className="web-span"
            dangerouslySetInnerHTML={{ __html: converted }}
          />
        ) : (
          <p className="web-span">{converted}</p>
        )}
      </div>
    );
  };

  return (
    <>
      <div className="fund-wrap-web m-2 mt-2 p-3">
        <p className="web-header">{sectionTitle}</p>
      </div>

      <div className="fund-wrap-content m-2 mt-2 p-3">
        <div className="d-flex justify-content-between align-items-center">
          <div className="recomandation-content" style={{ gap: '16px' }}>
            {filteredFields?.length > 0 ? (
              filteredFields?.map(renderField)
            ) : (
              <p className="web-span">No fields configured for this section.</p>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
